export default __webpack_public_path__ + "static/media/phone-with-hand.b0d27566.svg";